module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [(!((_vm.path_name == 'Product') || (_vm.path_name == 'RefProduct'))) ? _c('div', {
    staticClass: "header-wrap-sticky"
  }, [_c('div', {
    staticClass: "header-wrap-inner",
    staticStyle: {
      "background-color": "#ff3c00",
      "margin": "0",
      "padding": "0.5em",
      "padding-left": "1em"
    }
  }, [_c('li', {
    staticClass: "header-left-2"
  }, [((_vm.path_name == 'Product') || (_vm.path_name == 'RefProduct')) ? _c('span', [_c('a', {
    staticClass: "header-nav-back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    staticStyle: {
      "color": "#ffffff"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#ffffff",
      "font-size": "20px",
      "font-weight": "500",
      "cursor": "pointer",
      "text-decoration": "none"
    }
  }, [_vm._v(_vm._s(_vm.product_name))])]) : _c('span', [_c('a', {
    staticStyle: {
      "color": "#ffffff",
      "font-size": "20px",
      "font-weight": "500",
      "cursor": "pointer",
      "text-decoration": "none"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v(_vm._s(_vm.path))])])])]), _vm._v(" "), _c('li', {
    staticClass: "header-right-2"
  }, [_c('ul', [(_vm.path_name != 'Product') ? _c('li', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.path_name == 'Product') ? _c('li', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('li', [_c('component-account-menu')], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "font-size": "22px",
      "font-weight": "400",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/search"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "padding-right": "7px",
      "font-size": "22px",
      "font-weight": "400",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d72d8db"}!./src/pages/Sellpoint/SellpointTemplate/template.html
// module id = 453
// module chunks = 0